import { useState } from 'react'

import {
  Input,
  LegacyPage,
  Stack,
  NumericInput,
  Json,
  Textarea,
  Form,
} from 'peach/components'

const ScratchForm = () => {
  const [number, setNumber] = useState(null)

  const [val, setVal] = useState({
    stringValue: 'a string',
    numericValue: 12,
    initallyEmptyNumericValue: null,
    anObject: { aNestedString: 'Hello' },
  })

  return (
    <LegacyPage>
      <Stack>
        <Json.Table json={{ number }} title='Numeric Value' />

        <NumericInput
          label='Numeric Value'
          nullable
          onChange={setNumber}
          value={number}
        />
        <Json.Table json={val} title='Form Value' />
        <Form.Provider onChange={setVal} value={val}>
          <Input
            formKey='stringValue'
            nullable
            onValidate={({ value }) =>
              value !== 'HELLO' && { errorMessage: `must be 'HELLO'` }
            }
          />

          <Form.Row>
            <NumericInput formKey='numericValue' />
            <NumericInput formKey='initallyEmptyNumericValue' />
          </Form.Row>
          <Input
            formKey='stringValue'
            note='this is a duplicate formkey (which will cause other parts of the form to be spookily updated)'
            required
          />
          <Form.Provider formKey='anObject' section>
            <Input formKey='aNestedString' required />
            <Textarea formKey='aSecondNestedString' required />
          </Form.Provider>
          <Textarea.Json formKey='anObject' />
          <Form.Debugger />
        </Form.Provider>
      </Stack>
    </LegacyPage>
  )
}

export default ScratchForm
